import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ArrowRight } from 'lucide-react';
import CourseMiniCard from './CourseMiniCard';
import { coursesFromApiResponse } from '@/lib/utils';
import { getApiBaseUrl } from '@/lib/apiBase';

const API_URL = getApiBaseUrl();
const SHOW = 6;

// Landing-page hero showcase: the first courses in admin-set order (GET /courses
// default sort). Desktop: right-hand hero column; mobile: stacks below the
// headline/CTA. Renders `fallback` while loading fails or there are no courses.
export default function HeroWithCourses({ fallback = null }) {
  const [courses, setCourses] = useState(null);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    axios.get(`${API_URL}/courses`, { params: { limit: SHOW } })
      .then(({ data }) => {
        setCourses(coursesFromApiResponse(data));
        setTotal(Number(data?.total) || 0);
      })
      .catch(() => setCourses([]));
  }, []);

  if (courses === null) {
    return (
      <div className="grid grid-cols-2 gap-3 sm:gap-4" aria-hidden="true">
        {Array.from({ length: SHOW }).map((_, i) => (
          <div key={i} className="aspect-[4/3] bg-gray-200/70 dark:bg-white/5 animate-pulse" />
        ))}
      </div>
    );
  }
  if (!courses.length) return fallback;

  return (
    <div data-testid="hero-courses">
      <div className="flex items-end justify-between mb-3">
        <p className="text-xs font-bold uppercase tracking-widest text-[#A67C52]">Start with these courses</p>
        {total > courses.length && (
          <span className="text-xs text-gray-500 dark:text-gray-400">{total} courses</span>
        )}
      </div>
      <div className="grid grid-cols-2 gap-3 sm:gap-4">
        {courses.map((course, i) => (
          <CourseMiniCard key={course.id} course={course} number={course.order || i + 1} />
        ))}
      </div>
      <Link
        to="/courses"
        className="mt-4 inline-flex items-center text-sm font-bold text-[#A67C52] hover:underline"
      >
        View all courses <ArrowRight className="ml-1.5 w-4 h-4" />
      </Link>
    </div>
  );
}
